import type { SampleMealDay } from './types';

/** Lấy phần ngày `YYYY-MM-DD` từ `YYYY-MM-DD` hoặc ISO có offset, không đổi theo múi giờ máy. */
function calendarDate(value: string | null | undefined): string | null {
  if (!value) return null;
  const match = /^(\d{4}-\d{2}-\d{2})/.exec(value);
  return match?.[1] ?? null;
}

function dayHasPhoto(day: SampleMealDay): boolean {
  if ((day.count ?? 0) > 0) return true;
  return day.photos?.some((photo) => !!photo.url) ?? false;
}

/**
 * Chỉ giữ ngày ăn của khách hàng.
 * `from`/`to` là `structuredData.metadata` của thực đơn rút gọn tuần đang xem.
 * Chưa có khoảng thì giữ nguyên danh sách LOGI trả về.
 */
export function filterSampleMealDays(
  days: SampleMealDay[],
  range: { from?: string | null; to?: string | null }
): SampleMealDay[] {
  const from = calendarDate(range.from);
  const to = calendarDate(range.to);
  if (!from || !to) return days;

  return days.filter((day) => {
    const photoDate = calendarDate(day.photo_date);
    if (!photoDate) return false;
    return photoDate >= from && photoDate <= to;
  });
}

/** Có ảnh trong các ngày ăn của tuần. Ảnh ngoài khoảng ngày ăn không tính. */
export function sampleMealWeekHasPhotos(
  days: SampleMealDay[] | undefined,
  range: { from?: string | null; to?: string | null }
): boolean {
  if (!days?.length) return false;
  return filterSampleMealDays(days, range).some(dayHasPhoto);
}
